import N8nText from './Text.vue';

export default N8nText;
